/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

/**
 * Valid pharmacy specialty types for DoseSpot.
 */
export type PharmacySpecialtyT =
  (typeof PharmacySpecialtyT)[keyof typeof PharmacySpecialtyT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PharmacySpecialtyT = {
  Any: "Any",
  FaxPharmacy: "FaxPharmacy",
  EPCS: "EPCS",
  TwentyFourHourPharmacy: "TwentyFourHourPharmacy",
  LongTermCarePharmacy: "LongTermCarePharmacy",
  MailOrder: "MailOrder",
  Retail: "Retail",
  SpecialtyPharmacy: "SpecialtyPharmacy",
} as const;
